/* eslint-disable @typescript-eslint/no-explicit-any */
import { IconChevronRight } from '@tabler/icons-react'
import { useFileListPaginated } from '@viterbit/web-app/dataAccess/useCase/file/useFileListPaginated'
import i18n from '@viterbit/web-app/i18n'
import SegmentNavLink from '@viterbit/web-app/shared/navigation/SegmentNavLink'
import clsx from 'clsx'
import * as React from 'react'
import ListItem from 'ui/src/components/List/ListItem'
import ListItemText from 'ui/src/components/List/ListItemText'
import Skeleton from 'ui/src/components/Skeleton'

import {DocumentProps } from '../../DocumentEmloyeeShared'

type DocumentEmployeeNavigationItemProps = {
    Icon: React.ElementType
    className: string
    path: string
} & DocumentProps

const styles = {
    root: 'hover:bg-grey-50',
    iconWrapper: 'flex items-center justify-center rounded-md aspect-square w-14'
}

const DocumentEmployeeNavigationItem = (props: DocumentEmployeeNavigationItemProps) => {
    const { Icon, className, path, type, employeeId } = props

    const { isLoading, total } = useFileListPaginated({
        query: {
            employeeId,
            type: type as any,
        }
    })

    const secondary = isLoading ? <Skeleton className='w-10 h-3 my-1'/> : `${total} ${i18n.t('personalArea:documents.files')}`

    return (
        <SegmentNavLink exact path={path} className={styles.root} activeClassName="bg-grey-50" >
            <ListItem >
                <div className={clsx(styles.iconWrapper, className)}>
                    <Icon stroke={1} color="white" width={36} height={36} />
                </div>                

                <ListItemText
                    primary={i18n.t(`personalArea:documents.type.${type}`)}
                    secondary={secondary}
                />

                <IconChevronRight className='text-grey-400'/>
            </ListItem>
        </SegmentNavLink>
    )
}

export default DocumentEmployeeNavigationItem
